export class DuplicationModel {
    constructor() {
        this.research = {
            demographicInsights: true,
            existingSolutions: true,
            curiosityCorruption: true,
            extraNotes: true
        };
        this.mechanism = true;
        this.brief = true;
        this.offerOwnerKey = "";
        this.offerID = "";
    }
}
